import type { ProductConfig } from '../types/product';

export interface ValidationError {
  path: string;
  message: string;
  value: unknown;
}

export function validateCoverageLevelLimits(productConfig: ProductConfig): ValidationError[] {
  const errors: ValidationError[] = [];
  const limits = productConfig.loadingConfig?.coverageLevelLimits;
  const globalLimits = productConfig.coverageConfig?.coverageLevelGlobalLimits;

  if (!limits || limits.enforcement !== 'range') return errors;

  const perils = Object.keys(limits.limits);
  for (const peril of perils) {
    const perilLimits = limits.limits[peril];
    if (!perilLimits) continue;

    for (const type of ['strike', 'exhaust'] as const) {
      const { min, max } = perilLimits[type];

      if (max < min) {
        errors.push({
          path: `loadingConfig.coverageLevelLimits.${peril}.${type}`,
          message: `Maximum must be greater than or equal to minimum (${type} for ${peril})`,
          value: { min, max },
        });
      }

      const global = globalLimits?.[peril];
      if (global) {
        const gMin = global[type].min;
        const gMax = global[type].max;
        if (min < gMin || min > gMax) {
          errors.push({
            path: `loadingConfig.coverageLevelLimits.${peril}.${type}.min`,
            message: `${type} min for ${peril} must be between ${gMin} and ${gMax}`,
            value: min,
          });
        }
        if (max < gMin || max > gMax) {
          errors.push({
            path: `loadingConfig.coverageLevelLimits.${peril}.${type}.max`,
            message: `${type} max for ${peril} must be between ${gMin} and ${gMax}`,
            value: max,
          });
        }
      }
    }
  }

  return errors;
}
